import { CommunicationResource } from "../locales";

export const communication: CommunicationResource = {
    digitalMaterial: "Digitaal materiaal",
    tastings: "Proeverijen",
    storeMaterial: "Winkelmateriaal",
    campaignMaterial: "Campagnemateriaal",
    news: "Nieuws",
};
